import React from "react";
import { PickupAssignmentWorkloadBlock } from "./PickupAssignmentWorkloadTags";
import type { DriverWorkloadTotals } from "./aggregateDriverWorkload";
import "./driversColumnWorkloadSummary.scss";

export type DriversColumnWorkloadSummaryProps = {
  driverCount: number;
  totals: DriverWorkloadTotals;
};

/**
 * Pooled delivery/pickup progress for the drivers currently shown in the column (same filter set as the list).
 */
export const DriversColumnWorkloadSummary: React.FC<DriversColumnWorkloadSummaryProps> = ({
  driverCount,
  totals,
}) => {
  return (
    <section className="pa-drivers-column-summary" aria-label="Drivers column workload summary">
      <div className="pa-drivers-column-summary__head">
        <span className="pa-drivers-column-summary__title">Workload in view</span>
        <span className="pa-drivers-column-summary__meta">
          {driverCount} {driverCount === 1 ? "driver" : "drivers"}
        </span>
      </div>
      <PickupAssignmentWorkloadBlock
        deliveriesCompleted={totals.deliveriesCompleted}
        numberOfDeliveries={totals.numberOfDeliveries}
        pickupsCompleted={totals.pickupsCompleted}
        numberOfPickups={totals.numberOfPickups}
        layout="expandedCardsOnly"
      />
    </section>
  );
};
